import { createContext } from "react";
const DoctorContext = createContext();
export default DoctorContext;
